import { render } from "./message-source-area.vue?vue&type=template&id=5179889c&scoped=true"
import script from "./message-source-area.vue?vue&type=script&lang=js"
export * from "./message-source-area.vue?vue&type=script&lang=js"

import "./message-source-area.vue?vue&type=style&index=0&id=5179889c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5179889c"]])

export default __exports__